import { camelCase as $camelCase, isEqual as $isEqual, upperFirst as $upperFirst, lowerFirst as $lowerFirst, merge as $merge, clone as $deepClone, debounce as $debounce, get as $lodashGet, set as $lodashSet } from "lodash";

// lodash方法
export { $camelCase, $isEqual, $upperFirst, $lowerFirst, $merge, $deepClone, $debounce, $lodashGet, $lodashSet };

// 空对象判断
export function $isEmptyObject(obj) {
  for (const name in obj) {
    return false;
  }
  return true;
}

/* 为空判断*/
export function $isNullOrEmpty(obj) {
  return (obj !== 0 || obj !== "0") && (obj === null || obj === undefined || obj === "" || obj === "null" || typeof obj === "undefined");
}

// 是否为对象
export function $isObject(obj) {
  return obj !== null && typeof obj === "object";
}

// 空数组
export function $isEmptyArr(arr) {
  return Array.isArray(arr) && arr.length === 0;
}

// 判断字符串是否为纯数字
export function isNumber(string) {
  // isNaN()的缺点就在于 null、空串会被按照0来处理
  return string !== null && string !== "" && !isNaN(string);
}

/**
 * 处理condition逻辑
 * @param conditionItem: 要执行的逻辑条件
 * @param conditionData: 判断源数据
 * @returns { Boolean } conditionResult 逻辑运行规则
 */
function _executeConditionUtil(conditionItem, conditionData) {
  const { keyword, key } = conditionItem;

  let result = false;
  let left = conditionItem.value;
  let right = conditionData[key];

  // 运算符为包含和不包含并且运算符左边是纯数字转为字符串
  if (["ic", "nic"].includes(keyword)) {
    left = $isNullOrEmpty(left) ? "" : left.toString();
  } else { // 纯字符串数字
    left = isNumber(left) ? parseFloat(left) : left;
    right = isNumber(right) ? parseFloat(right) : right;
  }

  switch (keyword) {
    case "eq":
      result = (left === right);
      break;
    case "not":
      result = (left !== right);
      break;
    case "gt":
      result = (left > right);
      break;
    case "lt":
      result = (left < right);
      break;
    case "ge":
      result = (left >= right);
      break;
    case "le":
      result = (left <= right);
      break;
    case "isEven":
      result = (left % 2 === 0);
      break;
    case "isOdd":
      result = (left % 2 !== 0);
      break;
    case "ic":
      result = (left.indexOf(right) !== -1);
      break;
    case "nic":
      result = (left.indexOf(right) === -1);
      break;
    default:
      result = false;
  }
  return result;
}

/**
 * 逻辑执行器, 对指定对象运行逻辑判断
 * @param conditionObject 要执行的逻辑条件
 * @param conditionData 要判断的对象
 * @return conditionResult 逻辑运行规则
 * keyword: {
 *   eq: 相等
 *   not: 不等
 *   gt: 大于
 *   lt: 小于
 *   ge: 大于等于
 *   le: 小于等于
 *   isEven: 偶数
 *   isOdd: 奇数
 *   ic: 包含
 *   nic: 不包含
 * }
 */
export function $executeCondition(conditionObject, conditionData) {
  if ($isEmptyObject(conditionObject) || $isEmptyObject(conditionData)) {
    return false;
  }

  const { AND: andConditionList = [], OR: orConditionList = [] } = conditionObject;
  // and条件
  let andConditionResult = true;
  // or条件为空时，值为 true， 存在OR条件时默认值为 false
  let orConditionResult = $isEmptyArr(orConditionList);

  // 遍历and条件
  andConditionList.forEach(item => {
    andConditionResult && (andConditionResult = _executeConditionUtil(item, conditionData));
  });

  // 遍历or条件
  orConditionList.forEach(item => {
    orConditionResult || (orConditionResult = _executeConditionUtil(item, conditionData));
  });

  return andConditionResult && orConditionResult;
}
